<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Stock</h4>
            <h6>Gérer votre Stock</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="PDF" @click.prevent="exportPDF"
              ><img src="@/assets/img/icons/pdf.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel" @click.prevent="exportCSV"
              ><img src="@/assets/img/icons/excel.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Imprimer" @click.prevent="printTable"
              ><i data-feather="printer" class="feather-printer"></i
            ></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Rafraîchir" @click.prevent="refreshList"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
            href="javascript:void(0);"
            class="btn btn-added"
            data-bs-toggle="modal"
            data-bs-target="#add-units"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather>Ajouter
            un Nouveau</a
          >
        </div>
      </div>
      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="Recherche" class="dark-input" v-model="searchQuery" />
                <a href="" class="btn btn-searchset" @click.prevent="applyFilters"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <!-- Filter panel removed -->
          <div class="table-responsive">
            <a-table :columns="columns" :data-source="filteredData" :row-selection="{}">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Product'">
                  <div class="productimgname">
                    <a href="javascript:void(0);" class="product-img stock-img">
                      <img
                        :src="
                          require(`@/assets/img/products/${record.Product_img}`)
                        "
                        alt="product"
                      />
                    </a>
                    <a href="javascript:void(0);">{{ record.Product }}</a>
                  </div>
                </template>
                <template v-else-if="column.key === 'Person'">
                  <div class="userimgname d-flex">
                    <a href="javascript:void(0);" class="product-img">
                      <img
                        :src="
                          require(`@/assets/img/users/${record.Person_img}`)
                        "
                        alt="product"
                      />
                    </a>
                    <a href="javascript:void(0);">Steven</a>
                  </div>
                </template>
                <template v-else-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-units"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <i data-feather="trash-2" class="feather-trash-2"></i>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>

  <manage-stocks-modal
    @stock-added="onStockAdded"
    @stock-updated="onStockUpdated"
    :data="selectedStock"
  ></manage-stocks-modal>
</template>
<script>
import { getStockData, deleteStock } from "@/services/stockService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getCompanyLogoDataUrl } from "@/services/companyService";
const columns = [
  {
    sorter: true,
  },
  {
    title: "Entrepôt",
    dataIndex: "entrepot_nom",
    sorter: { compare: (a, b) => String(a.entrepot_nom || "").localeCompare(String(b.entrepot_nom || "")) },
  },
  {
    title: "Stock Optimal",
    dataIndex: "produit_stock_optimal",
    sorter: { compare: (a, b) => (Number(a.produit_stock_optimal) || 0) - (Number(b.produit_stock_optimal) || 0) },
  },
  {
    title: "Produit",
    dataIndex: "produit_nom",
    sorter: { compare: (a, b) => String(a.produit_nom || "").localeCompare(String(b.produit_nom || "")) },
  },
  {
    title: "Quantité",
    dataIndex: "quantite",
    sorter: { compare: (a, b) => (Number(a.quantite) || 0) - (Number(b.quantite) || 0) },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const data = [];
import Swal from "sweetalert2";
import { toast } from "vue3-toastify";

export default {
  data() {
    return {
      searchQuery: "",
      data,
      columns,
      selectedStock: {},
      filteredData: [],
    };
  },
  methods: {
    refreshList() { this.getStocksData(); },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce Stock ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteStock(id);
            if (localStorage.getItem("stocks") != null) {
              let stocks = JSON.parse(localStorage.getItem("stocks"));
              stocks = stocks.filter((item) => item.id !== id);
              const jsonData = JSON.stringify(stocks);
              localStorage.setItem("stocks", jsonData);
            }

            this.data = this.data.filter((item) => item.id !== id);
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Le Stock a été supprimer.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(error.response.data.message);
            toast.error(error.response.data.error);
          }
        }
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getStocksData() {
      this.data = [];
      if (localStorage.getItem("stocks") != null) {
        const data = JSON.parse(localStorage.getItem("stocks"));
        data.map((m) => {
          this.data.push({
            id: m.id,
            societe_id: m.societe_id,
            quantite: m.quantite,
            produit_id: m.produit_id,
            entrepot_id: m.entrepot_id,
            entrepot_nom: m.entrepot.nom,
            produit_stock_optimal: m.produit.stock_optimal,
            produit_nom: m.produit.nom,
            produit: m.produit,
            entrepot: m.entrepot,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
      } else {
        try {
          const data = await getStockData();
          data.map((m) => {
            this.data.push({
              id: m.id,
              societe_id: m.societe_id,
              quantite: m.quantite,
              produit_id: m.produit_id,
              entrepot_id: m.entrepot_id,
              entrepot_nom: m.entrepot.nom,
              produit_stock_optimal: m.produit.stock_optimal,
              produit_nom: m.produit.nom,
              produit: m.produit,
              entrepot: m.entrepot,
              CreatedOn: this.formatDate(m.created_at),
            });
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
      this.filteredData = [...this.data];
    },
    applyFilters() {
      const q = (this.searchQuery || '').toLowerCase().trim();
      if (!q) { this.filteredData = [...this.data]; return; }
      this.filteredData = this.data.filter((r) =>
        [r.produit_nom, r.entrepot_nom, r.quantite, r.produit_stock_optimal, r.CreatedOn]
          .filter(Boolean)
          .map((v) => v.toString().toLowerCase())
          .some((v) => v.includes(q))
      );
    },
    async exportPDF() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      if (!rows.length) return;
      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const headerHeight = 26; const margin = 12;
      let logo = null; try { logo = await getCompanyLogoDataUrl('logo'); } catch(e) { /* ignore logo load */ }
      const drawHeader = () => {
        if (!logo) return; const w = 42, h = 16, x = (pageWidth - w)/2, y = 8;
        try { const fmt = logo.startsWith('data:image/png') ? 'PNG' : 'JPEG'; doc.addImage(logo, fmt, x, y, w, h); } catch(_) { /* ignore addImage */ }
      };
      const body = rows.map(r => [ r.produit_nom||'-', r.entrepot_nom||'-', r.quantite!=null?String(r.quantite):'-', r.produit_stock_optimal!=null?String(r.produit_stock_optimal):'-', r.CreatedOn||'-' ]);
      autoTable(doc, {
        startY: headerHeight,
        head: [[ 'Produit', 'Entrepôt', 'Quantité', 'Stock Optimal', 'Date' ]],
        body,
        headStyles: { fillColor: [30,104,163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 60 }, 2: { cellWidth: 25, halign: 'center' }, 3: { cellWidth: 30, halign: 'center' }, 4: { cellWidth: 35, halign: 'center' } },
        alternateRowStyles: { fillColor: [245,245,245] },
        didDrawPage: () => {
          drawHeader();
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
          doc.setFontSize(9); doc.setTextColor(120);
          doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 8, { align: 'right' });
          doc.setTextColor(0);
        },
        margin: { left: margin, right: margin, top: headerHeight + 4, bottom: 15 }
      });
      doc.save(`stocks_${new Date().toISOString().slice(0,10)}.pdf`);
    },
    exportCSV() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      const headers = ['Produit','Entrepôt','Quantité','Stock Optimal','Date'];
      const csv = [ headers.join(','), ...rows.map(r => [ r.produit_nom||'', r.entrepot_nom||'', r.quantite!=null?r.quantite:'', r.produit_stock_optimal!=null?r.produit_stock_optimal:'', r.CreatedOn||'' ].map(v => `"${String(v).replace(/"/g,'""')}"`).join(',')) ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob); const a = document.createElement('a');
      a.href = url; a.download = `stocks_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    },
    printTable() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      const win = window.open('', '_blank');
      const html = `
        <html><head><title>Liste des Stocks</title>
        <style>table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:6px;text-align:left}</style>
        </head><body>
        <h3>Liste des Stocks</h3>
        <table><thead><tr><th>Produit</th><th>Entrepôt</th><th>Quantité</th><th>Stock Optimal</th><th>Date</th></tr></thead>
        <tbody>
          ${rows.map(r => `<tr><td>${r.produit_nom||''}</td><td>${r.entrepot_nom||''}</td><td>${r.quantite!=null?r.quantite:''}</td><td>${r.produit_stock_optimal!=null?r.produit_stock_optimal:''}</td><td>${r.CreatedOn||''}</td></tr>`).join('')}
        </tbody></table>
        </body></html>`;
      win.document.open(); win.document.write(html); win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch(e){ /* ignore */ } }, 100);
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    onStockAdded() {
      this.getStocksData();
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Stock créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    onStockUpdated() {
      this.getStocksData();
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Stock modifié avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    openEditModal(item) {
      this.selectedStock = item;
    },
  },
  mounted() {
    this.getStocksData();
  },
  watch: { searchQuery() { this.applyFilters(); } },
};
</script>
